var React = require('react');
var ResponsiveImage = require('../../common/ResponsiveImage.jsx');
var Video = require('../../common/Video.jsx');
    
var EditorialModule = React.createClass({
    getRelativeTime: function(dateString){
        
        var timeToShow;
        var wordToShow;
        var timeInMilli;
        var displayTime = '';
        
        try{
        	timeInMilli = moment.utc().diff(moment.utc(dateString));
        	timeToShow = timeInMilli/60000;
        	wordToShow = 'm';
        	if (timeToShow <= 0) {
        		timeToShow = 1;
        	}
        	if (timeToShow >= 60) {
        		timeToShow = Math.round(timeToShow/60.0);
        		if (timeToShow < 24){
        			wordToShow = 'h';
        		}
        		else{
        			timeToShow = Math.round(timeToShow/24.0);
        			wordToShow = 'd';
        		}
        	}
        	displayTime = displayTime + Math.round(timeToShow) + wordToShow;
        }catch(e){}
        return displayTime;
    },
    render: function(){
        
        var links = this.props.links || [];
        var title = this.props.title;
        var getRelativeTime = this.getRelativeTime;
        var list = [];
        
        links.map(function(link, i){
            var links = link.links || {web:{href:''}};
            var author = link.byline || '';
            var timestamp = getRelativeTime(link.lastModified);
            var mediaHeadline = '';
            var originalHref = '';
            var meta = null;
            
            if(!!author){
                meta = (
                    <div className="item-meta">
                        <span className="timestamp">{timestamp ? timestamp + ' - ' : ''}</span>
                        <span className="author">{author}</span>
                    </div>
                );
            }
            
            if(link.video && link.video.length){
                originalHref = '' + links.web.href;
                mediaHeadline = link.headline || link.video[0].headline;
                links.web.href = links.web.href.replace('http://espn.go.com','http://espn.co.uk');
                list.push(
                    <li key={link.linkText+'.vid'}>
                        <Video href={originalHref} headline={mediaHeadline} duration={link.video[0].duration} thumbnail={link.video[0].images[0].url} />
                    </li>
                );
            }else if(link.images && link.images.length){
                list.push(
                    <li key={(link.linkText || link.headline)+'.img'}>
                        <ResponsiveImage url={links.web.href} image={link.images[0]} />
                    </li>
                );
            }
            list.push(
                <li key={(link.linkText || link.headline) + '.txt'} className="text-container">
                    <h2><a target="_blank" className={/espn.co.uk/.test(links.web.href) ? '' : 'external'} href={links.web.href}>{mediaHeadline || link.linkText}</a></h2>
                    {meta}
                    <p>{link.description}</p>
                </li>
            );
        });
        
        return (
            <article className="sub-module">
                <header>
                    <h1>{title}</h1>
                </header>
                <ul className="content">
                    {list}
                </ul>
            </article>
        );
    }
});

module.exports = EditorialModule;


/** WEBPACK FOOTER **
 ** C:/gitrepos/espn-react-app/app/components/common/rhs/EditorialModule.jsx
 **/